import { CashReconciliationSummary } from '../Model/cashReconciliationXModel'

export const reportStationName = (report: CashReconciliationSummary) =>
  report.stationName || report.stationId
